
export type MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwoType = typeof MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwoType[keyof typeof MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
